import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";

import { fetchallmapmodulerole } from "../../../../services/apiService";
import AddMapModule from "./AddMapModule";
import Topbar from "../../../../scenes/global/Topbar";

const GyanniMapModule = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const clientId = localStorage.getItem("clientId");
  const orgId = localStorage.getItem("organizationid");

  const [roleData, setRoleData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [offset, setOffset] = useState(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);

  const [filterModel, setFilterModel] = useState({
    items: [],
  });

  useEffect(() => {
    const fetchRoles = async () => {
      setLoading(true);

      const totalRecordsParams = {
        clientid: Number(clientId),
        organizationid: Number(orgId),
        limit: 100,
      };

      try {
        const initialData = await fetchallmapmodulerole(totalRecordsParams);
        const total = initialData?.details?.total || 0;
        setTotalRecords(total);

        const secondRequestParams = {
          clientid: Number(clientId),
          organizationid: Number(orgId),
          limit: total,
        };

        const response = await fetchallmapmodulerole(secondRequestParams);

        if (response.success && response.details?.values?.length) {
          const mappedData = response.details.values.map((item) => ({
            id: item.roleid, // You can use item.id if it's reliable
            clientidname: item.clientidname,
            modulename: item.modulename,
            organizationid: item.organizationid,
            organizationname: item.organizationname,
            role: item.role,
            roleid: item.roleid,
          }));
          setRoleData(mappedData); // ✅ Set only if data exists
        } else {
          setRoleData([]); // ✅ Empty array fallback
        }
      } catch (error) {
        console.error("Error fetching role mapping:", error);
        setRoleData([]); // ✅ Fallback to prevent undefined
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, []);

  const handleFilterChange = (newFilterModel) => {
    setFilterModel(newFilterModel);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleEdit = () => {
    console.log("Editing client:", currentRow);
  };

  const handleDelete = () => {
    console.log("Deleting client:", currentRow);
  };

  const columns = [
    {
      field: "clientidname",
      headerName: "Client Name",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "modulename",
      headerName: "Module Name", // corrected label
      flex: 1,
    },
    {
      field: "organizationname",
      headerName: "Organization Name", // corrected label
      flex: 1,
    },
    {
      field: "role",
      headerName: "Role Name", // clarified
      flex: 1,
    },
    {
      field: "roleid",
      headerName: "Role ID", // clarified
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: ({ row }) => (
        <div style={{ display: "flex" }}>
          <IconButton
            onClick={() => handleEdit(row)}
            style={{ color: "#6870fa", fontSize: "12px" }}
          >
            <BorderColorIcon />
          </IconButton>
          <IconButton
            onClick={() => handleDelete(row)}
            style={{ color: "red", fontSize: "12px" }}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="mt-4">
        <Topbar />
      </div>
      <Box m="20px" style={{ backgroundColor: colors.primary[400] }}>
        <div className="p-4 flex items-center justify-between">
          <h2 className="">Map Module with Role</h2>
          <div
            style={{ backgroundColor: colors.blueAccent[500] }}
            className="text-white px-4 py-2 rounded-sm"
          >
            <button onClick={openModal} className="font-medium">
              {" "}
              <AddIcon /> Add
            </button>
          </div>
        </div>

        <Box
          m="0 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >
          <DataGrid
            checkboxSelection
            rows={roleData}
            columns={columns}
            pageSize={pageSize}
            page={page - 1}
            onPageChange={(newPage) => setPage(newPage + 1)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            pagination
            loading={loading}
            rowCount={roleData.length}
            getRowId={(row) => row.roleid} // ✅ REQUIRED if no `id` field
          />
        </Box>

        <AddMapModule isModalOpen={isModalOpen} closeModal={closeModal} />
      </Box>
    </>
  );
};

export default GyanniMapModule;
